module.exports = __webpack_public_path__ + "static/img/navbar_4.2b10ae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/navbar_4.png
// module id = ndNc
// module chunks = 25